export interface Size {
    width: number;
    height: number;
}

export const emptySize: Size = {
    width: 0,
    height: 0,
};
